import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ReplenishmentComponent } from "./replenishment.component";

const routes : Routes = [
  {
    path: "",
    component: ReplenishmentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ReplenishmentRoutingModule {}
